// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"edit-2"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3.00049 21.0007L7.50024 20.9998L17.5002 10.9998L13.0002 6.5L3.0005 16.4998L3.00049 21.0007Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M21.5 7L17 2.5L13 6.5L17.5 10.9998L21.5 7Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M13.0002 6.5L3.0005 16.4998L3.00049 21.0007L7.50024 20.9998L17.5002 10.9998M13.0002 6.5L17.0002 2.5L21.5002 7L17.5002 10.9998M13.0002 6.5L17.5002 10.9998","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M21 21.0008L14 21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Edit2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'edit-2',
    ref,
    icon: element,
  },
));

Edit2Icon.displayName = 'Edit2Icon';

export default Edit2Icon;
